import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { mergeInitialValues } from '@utils/formik';
import { useFormValues } from '@components/HealthQuoteBuyRoute/HealthQuoteBuyCustomForm';

import { selectPersonalAccidentQuoteBuyRoute } from '../selector';

export const useInitialValues = () => {
  const { personalAccidentQuote } = useSelector(selectPersonalAccidentQuoteBuyRoute);
  const values = useFormValues();

  return useMemo(() => {
    if (!personalAccidentQuote) return null;
    const { members } = personalAccidentQuote;
    return mergeInitialValues(values, { ...personalAccidentQuote, ...members });
  }, [personalAccidentQuote]);
};
